// removed by extract-text-webpack-plugin
module.exports = {"header":"_1jrRU3WDUv5JaNLnAkJuKW","name":"_2JCdx_4ZPQOyjG9Mgii-UV c-white fontSize-xl fontWeight-5 marginBottom-xxs","description":"-RqVj8BG6cKX9HKhLMflv c-white lineHeight-s fontSize-s fontWeight-3","pricing":"esN9sDjQn8LZsvhhzynSa c-white fontSize-xxl fontWeight-5 lineHeight-xl","button":"_5MLcCw96b43s2A-lJxciI bg-white boxShadow-emboss--hover button--m button--rounded button c-slate","features":"_2ru0CIfHuQ2Sq1q0vXTN-2 paddingLeft-xs paddingTop-m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Pricing/EnterpriseCard/EnterpriseCard.css
// module id = 766
// module chunks = 18116671869107 156544657062075